import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useHandleEditProject = (projectId?: string, methodology?: string) => {
    const navigate = useNavigate();

    return useCallback(() => {
        if (projectId) {
            navigate(`/projects/${methodology}/${projectId}/edit`);
        }
    }, [methodology, navigate, projectId]);
};
